import React from 'react';
import SpotifyAPI from '../utils/api';
import User from './User';

export default class App extends React.Component {

    state = {
        access_token: '',
        user: null,
        tracks: [],
        playlists: [],
        loading: false,
        total: 0,
        percent: 0,
        error: null,
        playlistTracks: []
    }

    api = null;

    componentDidMount(){
        let args = this.parseArgs();
        console.log(args)
        if('access_token' in args){
            this.setState({
                access_token: args.access_token
            })
            this.api = new SpotifyAPI(args.access_token);
            this.fetchProfile(args.access_token);
            let spotify = {
                token: args.access_token,
                expires: (+ new Date()) + (args.expires_in * 1000) //add one hour to now
            }
            localStorage.setItem('spotify_token', JSON.stringify(spotify));
        }else if(localStorage.getItem('spotify_token')){
            let stored = localStorage.getItem('spotify_token');
            let spotify = JSON.parse(stored);
            //token is still valid
            if(spotify.expires > (+ new Date())){
                this.api = new SpotifyAPI(spotify.token);
                this.fetchProfile(spotify.token);
                this.setState({
                    access_token: args.access_token
                })
            }
            
        }
    }

    fetchProfile = async (token) => {
        try{
            let response = await this.api.get('/me', token);
            console.log(response)
            let user = {
                name: response.display_name,
                url: response.external_urls.spotify,
                avatarURL: response.images.length > 0 ? response.images[0].url : undefined
            };
            let tracks = await this.fetch();
            let playlists = await this.fetch('/me/playlists');
            user.tracks = tracks.total;
            user.playlists = playlists.total;
            this.setState({
                user,
                total: tracks.total
            })
        }catch(e){
            if(e.message.includes(401)){
                console.warn('Bad token')
            }
            console.error(e);
            this.setState({
                error: 'Error loading your Spotify profile'
            })
        }
    }

    fetch = async (url = '/me/tracks') =>{
        try{
            let response = await this.api.get(url);
            return response;
        }catch(e){
            this.setState({
                error: 'Something went wrong loading your tracks...'
            })
            console.error(e);
        }
        
    }

    parseArgs = () => {
        var hash = window.location.hash.replace(/#/g, '');
        var all = hash.split('&');
        var args = {};
        all.forEach(arg => {
            var split = arg.split('=');
            let [key, value] = split;
            args[key] = value;
        });
        return args;
    }
    getUrl = () => {
        var client_id = '50308104884f4752bddcaf124375690a';
        //spotify api redirect url
        //var redirect_uri = 'http://localhost:3000';
        var redirect_uri = 'https://dev.peterfiorella.com/spotifysaved';
        var url = 'https://accounts.spotify.com/authorize?client_id=' + client_id +
        '&response_type=token' +
        '&scope=' + encodeURIComponent('user-library-read playlist-read-private') +
        '&redirect_uri=' + encodeURIComponent(redirect_uri);
        return url;
    }

    loadTracks = async (tracks) => {
        const { total } = this.state;
        let found = tracks.items.map(item => {
            return {
                name: item.track.name,
                artist: item.track.artists.map(artist => artist.name).join(', '),
                album: item.track.album.name,
                uri: item.track.uri,
                added: item.added_at
            }
        })
        this.setState((prevState) => {
            return {
                tracks: prevState.tracks.concat(found)
            }
        })
        if(tracks.next){
            let nextTracks = await this.fetch(tracks.next);
            this.setState({
                percent: (this.state.tracks.length / total) * 100
            })
            await this.loadTracks(nextTracks);
        }else{
            this.exportJSON(this.state.tracks);
        }
    }

    loadPlaylistTracks = async (tracks) => {
        let found = tracks.items.map(item => {
            return {
                name: item.track.name,
                artist: item.track.artists.map(artist => artist.name).join(', '),
                album: item.track.album.name,
                uri: item.track.uri,
                added: item.added_at
            }
        })
        this.setState((prevState) => {
            return {
                playlistTracks: prevState.playlistTracks.concat(found)
            }
        })
        return found;
        // if(tracks.next){
        //     let nextTracks = await this.fetch(tracks.next);
        //     await this.loadPlaylistTracks(nextTracks);
        // }else{
        //     return this.state.playlistTracks;
        // }
    }

    loadPlaylists = async (playlists) => {
        const { total } = this.state;
        let found = await Promise.all(playlists.items.map(async item => {
            try{
                let tracks = await this.api.get(item.tracks.href);
                console.log(tracks)
                let playlistSongs = await this.loadPlaylistTracks(tracks);
                return {
                    name: item.name,
                    public: item.public,
                    tracks: playlistSongs,
                    song_count: item.tracks.total
                }
            }catch(e){
                return {
                    name: item.name,
                    public: item.public,
                    song_count: item.tracks.total   
                }
            }
        }))
        this.setState((prevState) => {
            return {
                playlists: prevState.playlists.concat(found)
            }
        })
        if(playlists.next){
            let nextPlaylists = await this.fetch(playlists.next);
            this.setState({
                percent: (this.state.tracks.length / total) * 100
            })
            await this.loadPlaylists(nextPlaylists);
        }else{
            this.exportJSON(this.state.playlists);
        }
    }

    exportPlaylists = async() => {
        this.setState({
            loading: true
        })
        let playlists = await this.fetch('/me/playlists');
        await this.loadPlaylists(playlists);
    }

    exportTracks = async () => {
        this.setState({
            loading: true
        })
        let tracks = await this.fetch();
        await this.loadTracks(tracks);
    }   

    exportJSON = (list) => {
        var content = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(list));
        var download = document.createElement('a');
        download.setAttribute("href", content);
        var filename = `spotify-saved-${+ new Date()}.json`;
        download.setAttribute("download", filename);
        download.click();
        download.remove();
        this.setState({
            loading: false
        })
    }

    render(){
        const {access_token, user, loading, percent, error} = this.state;
        return (
            <div>
                <div className="px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
                    <h1 className="display-4">Spotify To JSON</h1>
                    <p className="lead">This tool exports all of your saved Spotify tracks and/or playlists to a JSON file for safe keeping.</p>
                    {access_token === '' && (
                        <div>
                            <p className='lead'>To get started, authorize access to your Spotify account.</p>
                            <a href={this.getUrl()} id="authorize" className="btn btn-lg btn-success"><i className="fab fa-spotify"></i> Authorize on Spotify</a>
                        </div>)
                    } 
                    {error && (
                        <div>   
                            <p className='text-danger'>{error}</p>
                            <a href='/'>Click here to retry</a>
                        </div>
                    )}               
                </div>
                {user !== null && <User user={user} exportTracks={this.exportTracks} loading={loading} percent={percent} getPlaylists={this.exportPlaylists}/> }
            </div>
        );
    }
}